var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalInfoCard = function SvgPersonalInfoCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    fill: "none",
    viewBox: "0 0 25 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.387 6.155h-6.686a.514.514 0 000 1.029h6.686a.514.514 0 000-1.029zM20.387 9.241h-6.686a.514.514 0 000 1.029h6.686a.514.514 0 000-1.029zM18.845 12.327H13.7a.514.514 0 000 1.029h5.144a.514.514 0 000-1.029z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M21.416.862H2.901C1.4.862.179 2.083.179 3.584v12.343c0 1.5 1.221 2.722 2.722 2.722h18.515c1.5 0 2.722-1.221 2.722-2.722V3.584c0-1.5-1.221-2.722-2.722-2.722zm1.393 15.065c0 .768-.625 1.393-1.393 1.393H2.901a1.395 1.395 0 01-1.393-1.393V3.584c0-.768.625-1.393 1.393-1.393h18.515c.768 0 1.393.625 1.393 1.393v12.343z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.9,
    d: "M7.498 8.944a1.472 1.472 0 100-2.944 1.472 1.472 0 000 2.944z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.9,
    d: "M11 12.929a3.558 3.558 0 00-7 0h7z"
  })));
};
export default SvgPersonalInfoCard;